export default class BillingForm {
    first_name: string;
    last_name: string;
    email: string;
    address: string;
    city: string;
    zip: string;
    country: string;
    state: string;
    phone: string;

    constructor() {
        this.first_name = '';
        this.last_name = '';
        this.email = '';
        this.address = '';
        this.city = '';
        this.zip = '';
        this.country = '';
        this.state = '';
        this.phone = '';
    }
}